export default "__VITE_ASSET__Dr1i0TKX__"